// client_bank_code (банк плательщика, который мерчант передаёт при создании заявки)
// -> id банка (core.Bank) в проде. Этот id уходит в URL шага перевода и как
// sender_bank в GET /payment_pages/routes_instructions/. Если код известен —
// окно выбора банка на main_page пропускается (P2P-1882, P2P-2965).
// Ключи — в нижнем регистре: мерчанты присылают код в разном регистре
// ('sber'/'SBER', 'Rossiya'/'rossiya'), сравнение регистронезависимое.
// sber = 9, а не 648: в проде СБЕР на main_page и инструкции Сбер -> Сбер
// заведены на банк id 9 (P2P-2965).
export const BANK_IDS = {
  sber: 9,
  tbank: 1,
  alfa: 8,
  vtb: 6,
  mts: 21,
  gazprom: 5,
  ros_selxoz: 13,
  mkb: 32,
  sovkom: 23,
  dom_rf: 10,
  raiffaizen: 7,
  rossiya: 76,
  ozon: 2,
  psb: 24,
  yoomoney: 273,
  wb: 209,
  tcell: 469,
  yandex: 30,
  uralsib: 37,
} as const;

export const getClientBankId = (clientBankCode?: string | null): number | null => {
  const code = clientBankCode?.trim().toLowerCase();
  if (!code || !Object.prototype.hasOwnProperty.call(BANK_IDS, code)) {
    return null;
  }
  return BANK_IDS[code as keyof typeof BANK_IDS];
};
